import { Button, Tag } from 'antd';
import React, { useEffect, useState } from 'react';
import PageHeaderComponent from '../../../helpers/components/page_header.component';
import TotpSetupFlow from './totp_setup_flow';
import totpService from '../../../services/admin/totp.service';

const TwoFaSettings = () => {
    const [state, setState] = useState({
        status_loading: false,
        is_enabled: false,
        enabled_at: null,
        step: 'idle', // 'idle' | 'setup'
    });

    const fetchStatus = async () => {
        setState(s => ({ ...s, status_loading: true }));
        const res = await totpService.getStatus().catch(() => null);
        setState(s => ({
            ...s,
            status_loading: false,
            is_enabled: res?.is_enabled ?? false,
            enabled_at: res?.enabled_at ?? null,
        }));
    };

    const onSetupSuccess = async () => {
        setState(s => ({ ...s, step: 'idle' }));
        await fetchStatus();
    };

    useEffect(() => {
        fetchStatus();
    }, []);

    if (state.step === 'setup') {
        return (
            <TotpSetupFlow
                on_success={onSetupSuccess}
                on_cancel={() => setState(s => ({ ...s, step: 'idle' }))}
                cancel_label="Cancel"
            />
        );
    }

    return (
        <div style={{ textAlign: 'start' }}>
            <PageHeaderComponent title={<span style={{ fontSize: 16 }}>Two-Factor Authentication</span>} />
            <div style={{ marginTop: 12 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16 }}>
                    <span style={{ fontSize: 14 }}>Status:</span>
                    {state.is_enabled ? (
                        <Tag color="green" style={{ border: 'none' }}>Enabled</Tag>
                    ) : (
                        <Tag color="orange" style={{ border: 'none' }}>Not enabled</Tag>
                    )}
                    {state.is_enabled && state.enabled_at && (
                        <span style={{ color: 'var(--secondary-text-color)', fontSize: 12 }}>
                            since {new Date(state.enabled_at).toLocaleDateString()}
                        </span>
                    )}
                </div>

                {!state.is_enabled && (
                    <>
                        <p style={{ color: 'var(--secondary-text-color)', marginBottom: 16 }}>
                            Add an extra layer of security to your account using Google Authenticator.
                        </p>
                        <Button
                            type="primary"
                            onClick={() => setState(s => ({ ...s, step: 'setup' }))}
                        >
                            Enable 2FA
                        </Button>
                    </>
                )}
            </div>
        </div>
    );
};

export default TwoFaSettings;
